import React, {useState, useCallback, createContext, useContext /* , useEffect */} from 'react'
import tail from 'lodash/tail'
import uniqueId from 'lodash/uniqueId'
import {translate} from 'react-i18next'
// import {NOTIFICATION_TYPES} from 'const/notifications'

const defaultAPI = {
  notifications: [],
  config: {
    max: 1,
    landing: false,
    sticky: true,
  },
  updateConfig: () => null,
  showNotification: () => null,
  hideNotification: () => null,
}

export const NotificationsContext = createContext(defaultAPI)
const NotificationsContextProvider = NotificationsContext.Provider
export const useNotificationsContext = () => useContext(NotificationsContext)

export const NotificationsProvider = translate()(({children, landing = false, sticky = true /* , t */}) => {
  const [config, setConfig] = useState({...defaultAPI.config, landing, sticky})
  const [notifications, setNotifications] = useState(defaultAPI.notifications)

  const showNotification = useCallback(
    (type, message, isDismissible = true) => {
      const newNotification = {
        id: uniqueId(),
        type,
        message,
        isDismissible,
      }

      // Check for duplicates and prevent them from being added
      const alreadyAdded = notifications.find(
        notification => notification.message === newNotification.message && notification.type === newNotification.type
      )

      if (!alreadyAdded) {
        if (notifications.length === config.max) {
          setNotifications([newNotification, ...tail(notifications)])
        } else {
          setNotifications([newNotification, ...notifications])
        }
      }
    },
    [notifications, setNotifications, config.max]
  )

  const hideNotification = useCallback(
    id => () => {
      setNotifications(notifications.filter(notification => notification.id !== id))
    },
    [setNotifications, notifications]
  )

  const updateConfig = useCallback(
    newConfig => {
      setConfig({config, ...newConfig})
    },
    [setConfig, config]
  )

  /*
  useEffect(() => {
    const message = t('notification.service-unavailable', {
      fallbackLng: 'de',
    })
    showNotification(NOTIFICATION_TYPES.error, message, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  */

  return (
    <NotificationsContextProvider
      value={{
        notifications,
        config,
        updateConfig,
        showNotification,
        hideNotification,
      }}>
      {children}
    </NotificationsContextProvider>
  )
})
